export default {
  methods: {
    retrieveWorkflowSummary(currentWorkflow) {
      const currentRoute = this.$route;

      const activeSection = currentWorkflow.find(section => section.children.find(page => page.name === currentRoute.name) !== undefined);
      const activeSectionIndex = currentWorkflow.indexOf(activeSection);

      const activeSectionPage = activeSection.children.find(child => child.name === currentRoute.name);
      const activeSectionPageIndex = activeSection.children.indexOf(activeSectionPage);

      const totalSectionSteps = activeSection.children.length;
      const currentSectionStep = activeSectionPageIndex + 1;
      const currentSectionPercentage = Math.round((currentSectionStep / totalSectionSteps) * 100);

      const allSteps = currentWorkflow.reduce((accumulator, currentValue) => {
        const childrenNames = currentValue.children.map(child => child.name);
        return accumulator.concat(childrenNames);
      }, []);

      const totalSteps = allSteps.length;
      const currentStep = allSteps.indexOf(currentRoute.name);
      const currentPercentage = Math.round((currentStep / totalSteps) * 100);
      const completePercentage = Math.max(Math.round(((currentStep - 1) / totalSteps) * 100), 0);


      return {
        activeSection,
        activeSectionIndex,
        activeSectionPage,
        activeSectionPageIndex,
        totalSectionSteps,
        currentSectionStep,
        currentSectionPercentage,
        totalSteps,
        currentStep,
        currentPercentage,
        completePercentage,
        allSteps,

      };
    }
  }
};
